module.exports = __webpack_public_path__ + "img/ico_earthtemperature0-15.a932355e.svg";